import type { ReactNode } from "react";

/** One numbered step of the planner. The head is the toggle and always carries
 * the step's summary, so three collapsed steps still read as the plan being
 * asked for: which sites, from where, over what day. */
export default function StepCard({
  n,
  title,
  summary,
  open,
  onToggle,
  children,
}: {
  n: number;
  title: string;
  summary: ReactNode;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  const bodyId = `planner-step-${n}`;
  return (
    <section className={open ? "step-card open" : "step-card"} aria-label={title}>
      <button type="button" className="step-card-head" aria-expanded={open} aria-controls={bodyId} onClick={onToggle}>
        <span className="step-card-num" aria-hidden="true">
          {n}
        </span>
        <span className="step-card-text">
          <span className="step-card-title">{title}</span>
          <span className="step-card-summary">{summary}</span>
        </span>
        <span className="step-card-action">{open ? "Done" : "Edit"}</span>
      </button>
      {open ? (
        <div className="step-card-body" id={bodyId}>
          {children}
        </div>
      ) : null}
    </section>
  );
}
